const messages = {
    title: 'footer.mobileBanner.title',
    text: 'footer.mobileBanner.text',
    playStoreImage: 'footer.mobileBanner.playStore.alt',
    appStoreImage: 'footer.mobileBanner.appStore.alt',
};
export default messages;
//# sourceMappingURL=messages.js.map